import {useState} from 'react';

interface FocusedElementProps {
  autoFocus: boolean;
  onFocus: () => void;
  onBlur: () => void;
}

type UseFocusStateOutput = [boolean, FocusedElementProps];

/**
 * Custom React hook to keep track of whether an element is focused or not. Works with any element
 * that accepts FocusedElementProps.
 *
 * See useFocusState.stories.tsx for example usage.
 */
export default function useFocusState(focusInitially: boolean): UseFocusStateOutput {
  const [isFocused, setIsFocused] = useState(focusInitially);

  return [
    isFocused,
    {
      autoFocus: focusInitially,
      onFocus: () => {
        setIsFocused(true);
      },
      onBlur: () => {
        setIsFocused(false);
      },
    },
  ];
}
